import { Answer } from '../answer/answer.model';
import { Question } from '../questions/question.model';
import { OnInteraction } from './on-interaction.model';
import { QuestionMapper } from '../../question-mapper';
import { AnswerMapper } from '../../answer-mapper';

// Without this dynamic parameter AOT compiling will fail.
// @see https://angular.io/guide/angular-compiler-options#strictmetadataemit
// @dynamic
export class GaveAnswer extends OnInteraction {
  public question: Question;

  public answer?: Answer;

  constructor(question: Question, answer?: Answer) {
    super();
    this.question = question;
    this.answer = answer;
  }

  public static fromDto(dto: any): GaveAnswer {
    return new GaveAnswer(
      QuestionMapper.fromDto(dto.question),
      dto.answer ? AnswerMapper.fromDto(dto.answer) : undefined,
    );
  }
}
